import * as React from "react";
import type { SVGProps } from "react";
const SvgMoneyDollarCircleOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18" {...props}
  >
    <circle
      cx={8.999}
      cy={9}
      r={7.917}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.999 5.25v.833M8.999 12.75v-.833M7.216 10.875A1.86 1.86 0 0 0 9 11.917c.916.1 1.746-.546 1.875-1.458v0c0-.63-.445-1.173-1.062-1.296l-1.626-.325a1.32 1.32 0 0 1-1.062-1.296v0A1.707 1.707 0 0 1 9 6.083a1.86 1.86 0 0 1 1.784 1.042"
    />
  </svg>
);
export default SvgMoneyDollarCircleOutline;
